import { Divider } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { FormattedMessage, useIntl } from 'react-intl'
import { MoovyLink } from '../../components'

const PaymentProviderInformation = () => {
  const intl = useIntl()
  return (
    <Grid
      container
      marginTop={8}
      rowGap={4}
      size={{ xs: 12, sm: 6 }}
      alignItems="center"
      justifyContent="center"
    >
      <Grid width="100%">
        <Divider />
      </Grid>
      <Typography variant="h6">
        <FormattedMessage id="page.webPayment.paymentProvider.heading" />
      </Typography>
      <Typography variant="body2">
        <FormattedMessage id="page.webPayment.paymentProvider.information" />
      </Typography>
      <Typography variant="body2" width="100%">
        <FormattedMessage id="page.webPayment.paymentProvider.details1" />
        <br />
        <FormattedMessage id="page.webPayment.paymentProvider.details2" />
        <br />
        <FormattedMessage id="page.webPayment.paymentProvider.details3" />
        <br />
        <FormattedMessage id="page.webPayment.paymentProvider.details4" />
        <br />
      </Typography>
      <Typography variant="body2">
        <MoovyLink.Link
          target="_blank"
          href={intl.formatMessage({
            id: 'page.webPayment.paymentProvider.url',
          })}
        >
          <FormattedMessage id="page.webPayment.paymentProvider.url" />
        </MoovyLink.Link>
      </Typography>
    </Grid>
  )
}

export default PaymentProviderInformation
